import {getField, updateField} from 'vuex-map-fields';

import {MmfVuexStoreHelper} from "../helpers/MmfVuexStoreHelper";

import {PagFilter} from "@/store/common/paginationFilter";

import _ from 'lodash';

export function newEntityStoreHelper(newEntityFunction, newFilterFunction) {
    return new MmfVuexStoreHelper({
        namespaced: true,
        state: {
            idReport: -1,
            baseModuleUrl: process.env.VUE_APP_ADM_API_URL + "adm-service/adm",
            rows: [],
            newRows: [],
            editingRows: [],
            checkedItems: [],
            sortingBy: [],
            switchModeRows: [],
            entity: newEntityFunction(),
            entityOrigin: {},
            filter: newFilterFunction(),
            fixedFilter: newFilterFunction(PagFilter),
            filterConfig: [],
            showValueEditor: false,
            showValueBoolean: false,
            showValueInput: false,
            showNoResultAlert: false,
            currentPage: 1,
            itemLimitationAlert: false,
            maxTableItemLimit: 8000,
            ignoreMaxTableItemLimit: false,
            checkChangesOnLoad: false,
            crudState: '',
            entityHolder: {},
            filterHolder: {},
            editReturnUrl: '',
            editReturnPathType: '',
            selectItems: new Map(),
            selectItemsRefreshFlag: false,
            selectRows: [],
            selectFilter: newEntityFunction(),
            //默认的row转option规则，可在store中用自定义规则进行覆盖
            selectRowsToItems: function (row) {
                return {value: row.id, text: row.name}
            },
            //是否需要刷新，list页面会watch该字段，true，就执行emFilter的查询。
            // emFilter查询后，会重新置位为false
            // 各种保存，删除后，如将它设为true，list页面就知道需要重新查询来刷新数据了
            needToRefresh: true,
        },
        getters: {
            getField,
            showValueEditor: state => {
                return state.showValueEditor
            },
            showValueBoolean: state => {
                return state.showValueBoolean
            },
            showValueInput: state => {
                return state.showValueInput
            },
            checkedItems: state => {
                return state.checkedItems
            },
            getCheckedItems: state => {
                return state.checkedItems
            },
            buildByEntityStoreHelper: () => true,
        },
        actions: {
            searchResultExport(context, entity) {
                var idReport = context.state.idReport;
                var filter = Object.assign({}, context.state.fixedFilter);

                filter.firstReg = 1;
                filter.numRegPag = context.state.maxTableItemLimit;
                filter.totalReg = -1;

                var reportParameters = {
                    'type': 'asynchronous',
                    'reportType': 'XLSX',
                    'idReport': idReport,
                    'filter': filter,
                    'fileName': entity
                }
                context.dispatch('report/generateReport', reportParameters, {root: true})
            },
            showItemLimitationAlert(context, entity) {
                if (context.state.itemLimitationAlert) {
                    context.commit(entity + '/setItemLimitationAlert', false, {root: true});
                    context.dispatch("base/showWarning", {
                        userAlertWarningStr: "Search Records Limitation. The number of items on search grid is higher than the default system limit (2000).",
                        userAlertWarningVisible: true,
                    }, {root: true});

                }
            },
            //重新载入rows之前的钩子函数，由base的MMFLoadRowsSearch调用，如果想在刷新记录后，执行一些操作，可以在store中复写该action
            afterLoadRowsTrigger(context, entity) {

            },
            //被作为entitySelect或entityModalSelect时，执行的查询操作
            retrieveForSelect(context, {entity, key}) {
                context.dispatch("api/post", {
                    url: (context.state.baseModuleUrl + "/" + entity + "/findByFilter"),
                    data: context.state.selectFilter,
                    commonErrorHandle: false
                }, {root: true})
                    .then(function (data) {
                        context.commit(entity + "/setSelectRows", data.data.list, {root: true})
                        let result = data.data.list.map(x => context.state.selectRowsToItems(x))
                        context.commit(entity + "/setSelectItems", {
                            data: result,
                            key: key
                        }, {root: true})
                    })
            },
            retrieveSelectForSelectFilterChange(context, data) {
                if (data.onChangeDispatchActionParams.selectFilterName && data.onChangeDispatchActionParams.selectEntityName) {
                    context.commit(data.onChangeDispatchActionParams.selectEntityName + "/setSelectFilterAttribute", {
                        //todo 如果已经是以Filter结尾了，就不拼装Filter了
                        key: data.onChangeDispatchActionParams.selectFilterName + "Filter",
                        newValue: data.newValue
                    }, {root: true})
                    context.dispatch(data.onChangeDispatchActionParams.selectEntityName + "/retrieveForSelect", data.onChangeDispatchActionParams.selectEntityName, {root: true})
                }
            },
            setNeedToRefresh(state, data) {
                context.commit('setNeedToRefresh', data, {root: false});
            }
        },
        mutations: {
            updateField,
            addEditingRow(state, row) {
                if (!state.editingRows.some(r => r === row)) {
                    // 使用 clone 的结果，这样取消后不影响原始数据
                    state.editingRows.push({...row});
                }
            },
            clearEditingRows(state) {
                state.editingRows = []
            },
            removeEditingRow(state, row) {
                state.editingRows = state.editingRows.filter(r => r.id !== row.id);
            },
            addNewRow(state, row) {
                if (!state.newRows.some(r => r === row)) {
                    state.newRows.push(JSON.parse(JSON.stringify(Object.assign(row, state.entityHolder))));
                }
            },
            removeNewRow(state, row) {
                state.newRows = state.newRows.filter(r => r !== row);
            },
            setRows(state, rows) {
                state.rows = rows;
            },
            setNewRow(state, parameters) {
                var stateRow = state.newRows.filter(r => r == parameters['row'])[0]
                stateRow[parameters.key] = parameters.newValue
            },
            setNeedToRefresh(state, data) {
                state.needToRefresh = data;
            },
            setRow(state, parameters) {
                let {row, key, newValue} = parameters;
                var stateRow = state.editingRows.filter(r => r.id == row.id)[0]
                stateRow[key] = newValue
            },
            addSwitchModeList(state, parameters) {
                let {row, key, newValue} = parameters;
                let index = _.findIndex(state.switchModeRows,
                    function (r) {
                        let stateRow = _.cloneDeep(row)
                        stateRow[key] = newValue
                        if (_.isEqual(r, stateRow))
                            return true;
                        stateRow[key] = !newValue
                        if (_.isEqual(r, stateRow))
                            return true;
                        return false;
                    }
                );
                if (index >= 0) {
                    state.switchModeRows[index][key] = newValue
                } else {
                    let stateRow = _.cloneDeep(row)
                    stateRow[key] = newValue
                    state.switchModeRows.push(stateRow)
                }
            },
            removeSwitchModeList(state, row) {
                state.switchModeRows = state.switchModeRows.filter(r => !_.isEqual(r, row));
            },
            setCheckChangesOnLoad(state, value) {
                state.checkChangesOnLoad = value;
            },
            setPagination(state, pagination) {
                state.fixedFilter.firstReg = pagination.firstReg
                state.fixedFilter.currentPage = pagination.currentPage
                state.fixedFilter.numRegPag = pagination.numRegPag
                if (pagination.totalReg > state.maxTableItemLimit && !state.ignoreMaxTableItemLimit) {
                    state.fixedFilter.totalReg = state.maxTableItemLimit
                    if (state.checkChangesOnLoad) {
                        state.itemLimitationAlert = true
                        state.checkChangesOnLoad = false
                    }
                } else {
                    state.fixedFilter.totalReg = pagination.totalReg
                }
            },
            setSortingBy(state, sortingBy) {
                state.sortingBy = sortingBy
                state.fixedFilter.sortingBy = sortingBy
            },
            changeAttributeRowState(state, rowStateParameters) {
                var attributeArray = state.entity[rowStateParameters.entityAttributeKey];
                var stateAttributeRow = attributeArray.filter(r => r == rowStateParameters.row)[0]
                for (const change in rowStateParameters.changes) {
                    stateAttributeRow.rowState[change] = rowStateParameters.changes[change]
                }
            },
            setAttributeRow(state, parameters) {
                var attributeArray = state.entity[parameters.entityAttributeKey];
                var stateAttributeRow = attributeArray.filter(r => r == parameters.row)[0]
                stateAttributeRow[parameters.key] = parameters.newValue
            },
            addAttributeRow(state, parameters) {
                var attributeArray = state.entity[parameters.entityAttributeKey];
                var stateAttributeRowExists = attributeArray.some(r => r == parameters.row)
                if (!stateAttributeRowExists) {
                    attributeArray.push(parameters.row);
                }
            },
            removeAttributeRow(state, parameters) {
                var attributeArray = state.entity[parameters.entityAttributeKey];
                var stateAttributeRow = attributeArray.indexOf(parameters.row)
                state.entity[parameters.entityAttributeKey].splice(stateAttributeRow, 1)
            },
            setAttributeRows(state, parameters) {
                state.entity[parameters.entityAttributeKey] = parameters.rows
            },
            setFixedFilter(state, {filterState = 'filter'}) {
                state.fixedFilter = Object.assign({}, state.fixedFilter, state[filterState])
            },
            setEntity(state, entity) {
                // state.entity = Object.assign(newEntityFunction(), entity);
                state.entity = JSON.parse(JSON.stringify(entity))
                //em写法,一种是引用，一种是浅克隆，为防止有意外影响，在这里先保留备注 - 2020-7-2
                // state.entity = entity;
            },
            setEntityOrigin(state, entity) {
                // state.entityOrigin = Object.assign(newEntityFunction(), entity);
                state.entityOrigin = JSON.parse(JSON.stringify(entity))
            },
            setEntityAttribute(state, parameters) {
                state.entity[parameters.key] = parameters.newValue;
            },
            setFilterAttribute(state, parameters) {
                state.filter[parameters.key] = parameters.newValue;
            },
            setNewEntity(state) {
                //深拷贝
                state.entity = JSON.parse(JSON.stringify(Object.assign(newEntityFunction(), state.entityHolder)))
            },
            setClearFilter(state) {
                //针对工作流的修改，如果filter有workflowQueryTypeFilter字段，保证它不会被清空 - 2020-3-20 by YuJiaBei
                let workflowQueryTypeFilter = ""
                if (state.filter["workflowQueryTypeFilter"]) {
                    workflowQueryTypeFilter = state.filter["workflowQueryTypeFilter"]
                }
                //把filterHolder覆盖上
                state.filter = JSON.parse(JSON.stringify(Object.assign(newFilterFunction(), state.filterHolder)))
                if (state.filter["workflowQueryTypeFilter"] === "") {
                    state.filter["workflowQueryTypeFilter"] = workflowQueryTypeFilter;
                }
                state.fixedFilter = JSON.parse(JSON.stringify(Object.assign(newFilterFunction(PagFilter), state.filterHolder)))
            },
            //不带filterHolder的清空
            setClearFilterWithoutHolder(state) {
                //针对工作流的修改，如果filter有workflowQueryTypeFilter字段，保证它不会被清空 - 2020-3-20 by YuJiaBei
                let workflowQueryTypeFilter = ""
                if (state.filter["workflowQueryTypeFilter"]) {
                    workflowQueryTypeFilter = state.filter["workflowQueryTypeFilter"]
                }
                //把filterHolder覆盖上
                state.filter = JSON.parse(JSON.stringify(newFilterFunction()))
                if (state.filter["workflowQueryTypeFilter"] === "") {
                    state.filter["workflowQueryTypeFilter"] = workflowQueryTypeFilter;
                }
                state.fixedFilter = JSON.parse(JSON.stringify(newFilterFunction(PagFilter)))
            },
            clearFixedFilter(state) {
                state.fixedFilter = newFilterFunction(PagFilter)
            },
            setCrudState(state, crudState) {
                state.crudState = crudState;
            },
            setCheckedItems(state, checkedItems) {
                state.checkedItems = checkedItems;
            },
            setIgnoreMaxTableItemLimit(state, ignoreMaxTableItemLimit) {
                state.ignoreMaxTableItemLimit = ignoreMaxTableItemLimit;
            },
            setRowsPerPage(state, rowsPerPage) {
                state.fixedFilter.numRegPag = rowsPerPage;
                state.currentPage = 1;
                state.fixedFilter.currentPage = 1;
                state.fixedFilter.firstReg = 0;
            },
            setCurrentPage(state, currentPage) {
                state.currentPage = currentPage
                state.fixedFilter.currentPage = currentPage
                state.fixedFilter.firstReg = (currentPage - 1) * state.fixedFilter.numRegPag;
            },
            setTotalRows(state, totalReg) {
                state.fixedFilter.totalReg = totalReg;
            },
            setItemLimitationAlert(state, itemLimitationAlert) {
                state.itemLimitationAlert = itemLimitationAlert
            },
            setShowNoResultAlert(state, showNoResultAlert) {
                state.showNoResultAlert = showNoResultAlert;
            },
            toggleShowValueEditor(state, payload) {
                var enty1 = JSON.parse(JSON.stringify(state.entity));
                state.showValueEditor = payload;
                //for some reason is resetting the entity
                state.entity = enty1;
            },
            toggleShowValueBoolean(state, payload) {
                var enty1 = JSON.parse(JSON.stringify(state.entity));
                state.showValueBoolean = payload;
                //for some reason is resetting the entity
                state.entity = enty1;
            },
            toggleShowValueInput(state, payload) {
                var enty1 = JSON.parse(JSON.stringify(state.entity));
                state.showValueInput = payload;
                //for some reason is resetting the entity
                state.entity = enty1;
            },
            //em add
            setSelectFilterAttribute(state, parameters) {
                state.selectFilter[parameters.key] = parameters.newValue;
            },
            setEntityHolder(state, entityHolder) {
                state.entityHolder = entityHolder;
            },
            setFilterHolder(state, filterHolder) {
                state.filterHolder = filterHolder
            },
            setFilterHolderAttribute(state, parameters) {
                state.filterHolder[parameters.key] = parameters.newValue;
            },
            setEditReturnUrl(state, editReturnUrl) {
                state.editReturnUrl = editReturnUrl
            },
            setEditReturnPathType(state, editReturnPathType) {
                state.editReturnPathType = editReturnPathType
            },
            //add by YuJiaBei on 2019-9-24
            //data包含key和value
            setStateAttribute(state, data) {
                var splited = data.key.split(".")
                var key = data.key
                var newValue = data.value
                //如果key是用"."进行的层级命名，就循环找到最后一层命名的字段，再赋值
                if (splited.length > 1) {
                    var baseAttribute = state[splited[0]]

                    baseAttribute = baseAttribute !== "" ? Object.assign({}, baseAttribute) : {}

                    var newAttribute = baseAttribute
                    for (var j = 1; j < splited.length; j++) {
                        var iKey = splited[j]
                        //j等于最后一项时，进行赋值，否则只递归向下层走
                        if (j === splited.length - 1) {
                            newAttribute[iKey] = data.value
                        }
                        newAttribute = newAttribute[iKey]
                    }
                    key = splited[0]
                    newValue = baseAttribute
                }
                state[key] = newValue;
            },
            setSelectFilter(state, data) {
                state.selectFilter = data
            },
            setSelectRows(state, data) {
                state.selectRows = data
            },
            setSelectItems(state, {data, key}) {
                state.selectItems.set(key, data);
                state.selectItemsRefreshFlag = !state.selectItemsRefreshFlag;
            }//end em add
        }
    })

}
